<template>
  <v-app>
     <v-app-bar
        height="145"
        flat
        app>
          <v-content class="pt-0 px-0 mx-0">
            <v-container fluid>
            <v-row>
              <v-col>
                <v-container style="max-width: 1200px;">
                  <v-toolbar flat>
                  <v-toolbar-title class="headline text-uppercase">
                    <v-img
                      max-width="406"
                      :src="logo"
                      :lazy-src="logo"
                    ></v-img>
                 </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                      <v-btn class="menu-items" href="/" text >
                        Home
                      </v-btn>
                      <v-btn class="menu-items" href="/about.php" text>About</v-btn>

                      <v-btn class="menu-items" href="/faq.php" text>FAQ</v-btn>

                      <v-btn class="menu-items" href="/contact.php" text>Contact</v-btn>

                      <v-btn active-class="menu-item-active" class="menu-items" to="providers" text>Service Providers</v-btn>
                      
                </v-toolbar-items>
                <v-menu
                  dark
                  bottom
                  origin="center center"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      dark
                      class="hidden-md-and-up"
                    >
                    <v-icon dark>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list color="primary" dark class="menu-items">
                    <v-list-item href="/">
                      <v-list-item-title>Home</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/about.php">
                      <v-list-item-title>About</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/faq.php">
                      <v-list-item-title>FAQ</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/contact.php">
                      <v-list-item-title>Contact</v-list-item-title>
                    </v-list-item>
                   <v-list-item to="providers">
                      <v-list-item-title>Service Providers</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/disaster.php">
                      <v-list-item-title>Disaster</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                  </v-toolbar>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
          </v-content>
        </v-app-bar>

        <v-container fluid class="pa-0 ma-0">
          <router-view />
        </v-container>
        <v-content>
      
      <v-container fluid class="primary" style="padding-top: 50px;padding-bottom: 50px;">
          <v-row
            align="center"
            justify="center"
            class="mb-5"
          >
            <v-card color="transparent"  flat tile>
             <img
                class="pa-3"
                :src="footer_logo"
              />
            </v-card>
       
          </v-row>

         <v-layout
            text-center
            wrap
          >
          <v-flex mb-4 class="white--text footer-text">
             Copyright 2019. Montana 2-1-1. All Rights Reserved.
          </v-flex>

         </v-layout>
        <v-layout
            text-center
            wrap
          >
          <v-flex mb-4 class="white--text footer-text">
             SITE DESIGNED BY
             <br />
             <v-btn class="white--text footer-text" text href="https://www.edgemarketingdesign.com">
               <img :src="edge_logo" />
             </v-btn>
          </v-flex>

         </v-layout>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import logo from "../../images/logo.png";
import united_way from "../../images/united-way.png";
import footer_logo from "../../images/footer-logo.png";
import airs from "../../images/airs.png";
import edge_logo from "../../images/edge.png"

export default {
  name: 'App',
  components: {},
  data: () => ({
    logo: logo,
    united_way: united_way,
    footer_logo: footer_logo,
    airs: airs,
    edge_logo: edge_logo,
  }),
};
</script>
<style>
.mt211-header {
      font-family: 'Montserrat', sans-serif !important;
}
.menu-items {
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  text-transform: capitalize !important;
  letter-spacing: 0px !important;
}
.menu-items:hover{
  color: red !important;
  
}

.menu-items::before {
   background-color: transparent !important;
}

.menu-item-active {
  color: red !important;
}

.menu-item-active::before {
  color: transparent !important;
}

.footer-text {
  font-family: 'Droid Serif', serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}


</style>
